import script from "./ConfirmationModal.vue?vue&type=script&setup=true&lang=js"
export * from "./ConfirmationModal.vue?vue&type=script&setup=true&lang=js"

import "./ConfirmationModal.vue?vue&type=style&index=0&id=a2a72f8c&lang=css"

const __exports__ = script;

export default __exports__